<template>
  <!-- PC端弹窗 -->
  <el-dialog
    v-if="!isMobile"
    :visible.sync="dialogVisible"
    title="隐私政策"
    width="80%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="privacy-dialog"
  >
    <div class="privacy-dialog-content">
      <div class="privacy-main" v-html="content"></div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleAgree" class="agree-btn"
        >同意</el-button
      >
    </div>
  </el-dialog>

  <!-- 移动端弹窗 -->
  <van-popup
    v-else
    v-model="dialogVisible"
    position="bottom"
    :style="{ height: '95%' }"
    round
    :close-on-click-overlay="false"
    class="privacy-popup"
  >
    <div class="privacy-popup-container">
      <div class="privacy-popup-header">
        <div class="privacy-popup-title">隐私政策</div>
        <van-icon name="cross" @click="dialogVisible = false" />
      </div>
      <div class="privacy-popup-content">
        <div class="privacy-main" v-html="content"></div>
      </div>
      <div class="privacy-popup-footer">
        <van-button type="primary" block @click="handleAgree" class="orange"
          >同意</van-button
        >
      </div>
    </div>
  </van-popup>
</template>

<script>
import { isMobileDevice } from "@/utils";

export default {
  name: "PrivacyPolicyDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobile: isMobileDevice(),
      dialogVisible: false,
      content: `更新日期：2025年【12】月【23】日
生效日期：2025年【12】月【23】日

引言
本隐私政策（以下简称"本政策"）适用于广州文石信息科技股份有限公司（注册地址：广州市南沙区市鱼路202号4栋101室）及其关联公司（以下简称"我们"或"文石"）所提供的服务。
以下所述服务（以下简称"本服务"）包括由文石开发或运营的网站（包括但不限于https://send2boox.com、https://sales.send2boox.com/a/repair/repairReq）、终端产品（包括但不限于阅读本、读写本、办公平板等）、BOOX助手APP以及BOOX助手PC端所提供的所有服务。
在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，特别应重点阅读我们以粗体、更大字号或下划线标识的条款内容，确保您充分理解解和同意之后再开始使用。除本政策外，在特定场景下，我们还会通过即时告知（形式包含但不限于弹窗、页面确认等）、指定页面说明（包括但不限于官方网站www.boox.com、微信公众号、微博官方号、终端产品说明书等）等方式，向您说明对应的信息收集目的、范围及使用方式，这些即时告知及指定页面说明构成本政策的一部分，并与本政策具有同等效力。如对本政策内容有任何疑问、意见或建议，您可通过本政策文末的联系方式与我们联系。
如果您不同意接受本政策或我们对本政策所做的任何修改，将可能导致本服务无法达到我们拟达到的服务效果，或者我们仅能提供基本服务。

名词解释
账号：指您使用文石产品与/或服务需要注册的ONYX账号，该账号由您负责保管，您应当对以您账号下进行的所有行为负法律责任。请您知晓，只有您在同意并遵守文石提供的《用户协议》和《隐私政策》后，才可进行ONYX账号的注册、使用。当您使用文石终端产品时，我们建议您在终端产品中登录ONYX账号，如果您不在终端产品中登录ONYX账号，那您将无法使用云服务功能。
关联公司：指任何直接或间接控制文石公司、受文石公司控制或与文石公司受共同控制的任何一方。此处的"控制"和"受控制"分别指通过投票权、合同或其他方式而督导某一方的管理政策的权利。广州文石信息科技有限公司深圳分公司为广州文石信息科技股份有限公司的分公司，文石科技有限公司为广州文石信息科技股份有限公司的全资子公司。
个人信息：指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。为免疑义，本隐私政策中所指的个人信息包含敏感个人信息。
敏感个人信息：指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账号、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。
去标识化：指个人信息经过处理，使其在不借助额外信息的情况下，无法识别特定自然人的过程。
匿名化：指个人信息经过处理无法识别特定自然人且不能复原的过程。
第三方SDK：文石提供的部分功能/服务由我们合作的第三方机构提供，我们会接入由第三方机构提供的软件开发包（SDK）以实现相关功能。
SSL：SSL（Secure Socket Layer）又称为安全套接层，是在传输通信协议（TCP/IP）上实现的一种安全协议；SSL支持各种类型的网络，同时提供三种基本的安全服务，均通过使用公开密钥和对称密钥技术以达到信息保密的效果。
Cookie：Cookie是您浏览网页时，网站服务器放在客户端（您的计算机、移动电话或其他智能终端内）里面的一个文本文件，可用于改善您的使用体验。
唯一设备标识符：唯一设备标识符（专属 ID 或 UUID）是指由设备制造商编入到设备中的一串字符，可用于以独有方式标识相应设备。唯一设备标识符有多种用途，包括可在不能使用cookies时用以提供广告。
固件：指由文石提供并负责维护的基于文石推出的终端产品上的操作系统软件。
IP地址：每台上网的设备都会指定一个编号，称为互联网协议 (IP) 地址。这些编号通常都是根据地理区域指定的。IP 地址通常可用于识别设备连接至互联网时所在的位置。
笔记：指由您使用文石推出的软件或者硬件终端产品上产生的包括但不限于文字、书写笔迹、图像、声音、视频等信息的文件。
user agent：用户代理（User Agent，简称 UA），是一个特殊字符串头，使得服务器能够识别您使用的操作系统及版本、CPU 类型、浏览器及版本、浏览器渲染引擎、浏览器语言、浏览器插件等。
应用程序包名：在android应用开发中,"包名"(Package Name)是指用于唯一标识一个Android应用程序的名称。

我们制定隐私政策的目的在于帮助您了解以下内容：
一、我们如何收集和使用您的个人信息
二、我们如何使用Cookies
三、我们如何存储和保护您的个人信息
四、如何管理您的个人信息
五、第三方服务
六、未成年人保护
七、通知和修订
八、如何联系我们

一、我们如何收集和使用您的个人信息
我们遵循合法、正当、必要原则，在本政策所述目的、方式和范围内收集、使用您的个人信息。如我们要将您的个人信息用于本政策未载明的用途，或将基于特定目的收集而来的信息用于其他目的，我们将依法通过即时告知（形式包括但不限于弹窗、页面确认等）、网站公告或其他合理方式另行征得您的同意。一旦您同意，上述用于本政策未载明的用途的个人信息，或者基于特定目的收集而来的用于其他目的个人信息，都会视为本政策的一部分，对于这些个人信息的处理也将适用本政策。
1.ONYX账号注册/登录
您可以通过手机号码、电子邮箱地址或微信授权中的一种方式注册/登录ONYX账号。您也可以通过第三方登录授权的方式注册/登录账号。当您选择通过手机号码或电子邮箱地址注册账号时，我们需要收集您的手机号码或电子邮箱地址，收集这些信息是为了帮助您创建账号和便于您使用本服务，同时保护您的账号的安全。您的ONYX账号信息会加密保存在我们的服务器上，只有您自己才能使用。
在您注册、登录ONYX账号或后续使用过程中，您可以提供其他额外个人基本信息：您的昵称、头像。但如果您不提供额外个人基本信息，并不会影响您的使用本服务，我们不会强制要求您提供该等信息。需要提醒的是，我们不会对您的头像进行人脸识别或从头像图片中提取人脸信息。
当您在文石终端产品进行账号注册/登录时，或者将终端产品与账号绑定时，您向我们提供的设备信息，包括设备型号、唯一设备标识符、固件信息。
您需要注册并登陆账号后，才可以正常使用登录后的服务，包括笔记和阅读数据的云服务。如果您不在终端产品上登录账号，或者不愿意将终端产品与账号绑定，您还是可以使用终端设备中的本地功能和服务。
我们在ONYX账号注册环节收集您的个人信息的目的是为了保护您的账号的安全，例如帮助您顺利登录ONYX账号，验证账号一致性，又例如帮助您找回账号。
2.阅读/日历
当您在文石终端产品使用阅读功能时，并且同意将阅读数据同步到云端时，您将向我们提供阅读数据，我们会将收集到的阅读数据和您的账号关联，并且加密保存在我们的服务器上。所述阅读数据包括但不限于所加入到终端设备的书籍的阅读进度、书签、批注、阅读时长、当日阅读数量、完成阅读书籍数量统计等。我们收集阅读数据的目的是为了让您在不同的文石终端产品中实现阅读数据的同步，并且帮助您统计和展示您的阅读数据。如果您不同意将阅读数据同步到云端，所述阅读数据只保存在文石终端产品的本地存储器中，我们不会收集所述阅读数据，而且您的文石终端产品的阅读功能还能正常使用。
当您使用OCR识别功能时，您向我们提供待处理的文档或图片，我们会对您提供的文档或图片进行处理，对您反馈识别结果。在这过程中，我们并不会额外搜集您的个人信息。
3.笔记
当您在文石终端产品使用笔记功能时，并且同意将笔记数据同步到云端时，您将向我们提供笔记数据，我们会将收集到的笔记数据和您的账号关联，并且加密保存在我们的服务器上。我们保存这些数据的目的仅为了实现您的笔记同步功能，便于您管理和浏览的已创建的笔记。我们只会对笔记数据进行加密处理。除非我们得到了您的授权或者法律法规允许，否则我们不会对您的笔记数据进行分析。您在文石终端产品上登录了账号，则您在文石终端产品使用笔记功能时，笔记同步功能时默认启用的，如果您不同意将笔记数据同步到云端，您可以在同步设置的界面关闭笔记同步的功能，由此，笔记数据只保存在文石终端产品的本地存储器中，我们不会收集所述笔记数据，而您的文石终端产品的笔记功能还能正常使用。
当您使用语音转文字功能时，笔记中插入的音频（包括但不限于录音）或者正在录制的音频可被识别转换为文本（包括但不限于识别到的文字、内容摘要、会议纪要等）时，我们会通过第三方SDK来对您提供的音频进行处理，得到识别结果（文本）。关于第三方SDK搜集个人信息的情况，可以参考本政策的第五章内容。
需要提醒的是，语音转文字的功能仅仅是为了将音频数据转化为文本信息，我们不会从音频数据中提取的您的声纹特征。
当您使用OCR识别功能时，您向我们提供待处理的文档或图片，我们会对您提供的文档或图片进行处理，对您反馈识别结果。在这过程中，我们并不会额外搜集您的个人信息。
4.ONYX输入法-语音输入
当你在文石终端产品上使用语音输入时，我们会通过第三方SDK来对您提供的语音进行处理，得到识别结果（文本）。关于第三方SDK搜集个人信息的情况，可以参考本政策的第五章内容。在这过程中，我们不会从音频数据中提取的您的声纹特征。
5.互传/推送/微信传输
您可以通过推送功能实现文石终端产品与其他终端（包括电脑和手机）在公共网络中的文件双向传输，您可以传输文件、图片、音频、视频文件，在此过程中，我们会收集您提供的文件，并加密保存于我们的服务器中。当您通过文石终端产品使用微信传输功能，我们将收集您的微信传输的记录，我们不会收集您通过微信传输所传输的任何文件，以实现微信传输的功能。
需要声明的是，文石基于为用户提供在不同设备/终端之间同步文件服务的目的，仅收集并存储这些信息，不会访问或使用这些信息，仅用户自身拥有权限使用和访问自己传输的文件信息。

6.网络阅读
您可以通过网络阅读功能实现网络链接的阅读功能，您可以上传网页链接，在此过程中，我们会收集您提供的网页链接内容，并保存于我们的服务器中。

7.小文AI
您可以通过文石终端产品使用我们所提供的小文AI产品，我们将收集您进行交互过程中所输入的文本信息，使用这些信息向您输出内容，以提供辅助阅读服务。请您知悉，我们的小文AI为通过第三方大模型为您具体提供服务，我们将在获取您同意的情况下，将您的输入信息传输至第三方大模型厂商并为您提供输出内容。

8.设备管理
您可以通过设备管理功能，管理ONYX账号所绑定的文石终端产品设备情况，并对设备进行解锁、解绑、重置密码等功能，以实现对设备的管理。

9.礼品中心
您可以通过礼品中心领取您所在购买文石终端产品过程中所获得的礼品，并通过输入订单中的手机领取您的礼品，并对礼品进行管理。

10.售后服务
当您通过售后网页（https://sales.send2boox.com/a/repair/repairReq），我们将通过收集您的设备信息（含序列号、开机密码、购买日期以及购买凭证）、阅读器的故障照片以及您寄出快递的信息，以收集您的售后信息。同时我们还将收集您的收货地址（包括姓名、手机号、详细地址），以用于为您寄回维修产品。

11.信息反馈
当您使用信息反馈功能、联系我们客服或通过其他途径向我们反馈产品使用过程中的问题时，我们会收集您的账号、您与我们的沟通记录和内容、与您需求相关联的其他必要信息，以便我们与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。在此过程中，您可以选择性地向我们提供日志信息和额外的联系方式，这两项信息属于非必要信息，您不提供的话，您还是能使用信息反馈功能。所述日志信息包括服务的每次访问时间、访问的页面路径、IP地址、事件信息（如错误、崩溃、重启、升级），收集该等日志信息有助于我们进行问题排查，保障服务稳定和网络安全。所述额外的联系方式包括手机和电子邮箱地址，收集该等额外的联系方式有助于我们及时与您联系，沟通问题解决方案和跟进问题处理进度。对于信息反馈过程中收集到的日志信息，我们会存储一年后删除。
12.权限调用
当您使用部分单项服务时，可能需要您在您的设备中开启特定的访问权限，以实现这些权限所涉及信息的收集和使用。该等单项服务包括但不限于：
如果您的设备配备摄像头同时您也允许我们访问您的摄像头，您可进行拍摄，拍摄的照片可以直接生成为笔记、插入到笔记内或者被传送到您的文石终端产品。
如果您允许我们访问您的相册，您可以实现你设备中的照片、图片或视频的取用与上传，便于您进行更换头像、在笔记中插入图片、使用图片生成笔记，或将照片、图片或视频传送到您的文石终端产品。
在您允许我们开启存储权限后，一方面，我们可以获取您的照片、媒体内容和文件等信息，这便于您在使用阅读功能时导入书籍、在使用笔记功能时导入文件；另一方面，便于我们将您创建的笔记、图片、文件保存到您的设备本地存储器中。
如果您允许我们开启麦克风权限后，我们可以获取您现场录制的语音，便于您使用语音转文字的功能、使用语音输入法或录制录音文件。
当您开启任一权限，即代表您授权我们可以收集和使用相关个人信息来为您提供相关服务；当您关闭任一权限，即代表您取消了相关授权,我们将不再基于该权限收集和使用您的相关个人信息，也不再为您提供该权限所对应的服务。请注意,您关闭权限的决定和行为，不会影响此前基于您的授权已经进行的个人信息收集及使用。

二、我们如何使用Cookie
为了能够向您提供依赖于Cookie的功能和服务，或为保证网站正常运转，我们会根据业务需要在您的计算机上或移动设备上存储、设定或取用cookies。Cookie 是一种网络服务器存储在计算机或移动设备上的纯文本文件。Cookie 的内容只能由创建它的服务器检索或读取。每个 Cookie 对您的网络浏览器或移动应用程序都是唯一的。
我们启用Cookie的目的与大多数网站或互联网服务提供商启用 Cookie 的目的一样，即改善用户体验。借助于 Cookie，网站能够记住您的单次访问或多次访问。借助于 Cookie，网站能够保存设置，例如计算机或移动设备的语言、字体大小和其他浏览偏好。这意味着，您无需在每次访问时重新配置您的偏好设置。如果某个网站不使用 Cookie，那么在您每一次打开网页时，该网站都会将其视为新访客。例如，如果您登录某个网站后转到另一个网页，该网站就不会识别出您，而您会被再次注销。
我们不会将 Cookie 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置，但您可能因为该等修改，无法登录或使用依赖于Cookie的服务或功能。

三、我们如何存储和保护个人信息
1.个人信息的存储
本服务仅面向于中国大陆地区（仅为本政策之目的，不包含中国香港特别行政区、中国澳门特别行政区和中国台湾省）提供。原则上，我们在中华人民共和国境内收集产生的个人信息，存储在中华人民共和国境内，不会进行跨境传输。
（1）存储信息的地点
文石遵守法律法规的规定，收集的有关您的信息和资料将保存在中华人民共和国境内大陆地区文石的服务器上。以下情形除外：
•法律法规有明确规定；
•获得您的明确授权；
•您使用的服务涉及跨境，文石需要向境外提供您的个人信息。
（2）存储信息的期限
一般而言，我们将在您使用文石产品与/或服务期间为实现本政策所述处理目的所必需的最短时间保留您的个人信息，除非可适用的法律法规或国家规范性文件另有规定。具体参考的法律法规包括：
（1）《网络安全法》第二十一条：采取监测、记录网络运行状态、网络安全事件的技术措施，并按照规定留存相关的网络日志不少于六个月。
（2）《电子商务法》第三十一条：商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；法律、行政法规另有规定的，依照其规定。
在超过上述期限，或您主动要求删除您的个人信息或注销您的账号后，我们将根据适用法律法规的要求尽快删除您的个人信息，除非可适用的法律法规或国家规范性文件要求在更长的期间内保留这些信息。但在下列情况下，文石因需符合法律要求，更改个人信息的存储时间：
•为遵守适用的法律法规等有关规定；
•为遵守法院判决、裁定或其他法律程序的规定；
•为遵守相关政府机关或法定授权组织的要求；
•文石有理由确信需要遵守法律法规等有关规定；
•为执行相关服务协议或本政策、维护社会公共利益，为保护您、文石、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途。
在您终止使用本服务后，文石会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。
当本服务发生停止运营的情形时，文石将采取包括发送通知和公告形式通知您，并在法律法规要求的期限内删除服务器中留存的您的个人信息。
2.个人信息的保护
我们非常重视信息安全，成立了专门的网络安全与数据安全管理部门，并采取一切合理可行的措施，保护您的个人信息：
（1）数据安全技术措施
我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问、使用、修改，避免数据的损坏或丢失。
我们的服务采取了多种加密技术，例如在某些服务中，我们将利用加密技术（例如SSL）对您的个人信息进行加密保存，并通过隔离技术进行隔离，以保护您的个人信息。我们还会采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。
（2）我们为保护个人信息采取的其他安全措施
我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。我们通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用。
我们通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。
我们还会举办安全和隐私保护培训课程，加强员工的安全意识以及对于个人信息保护政策和相关规程的认识。
（3）我们仅允许有必要知晓这些信息的本公司员工、合作伙伴访问您的个人信息，并为此设置了严格的访问权限控制和监控机制。我们同时要求可能接触到您的个人信息的所有人员履行相应的保密义务。如果未能履行这些义务，该访问人员会被追究法律责任或被中止与我们的合作关系。
（4）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。
（5）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
（6）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件发生的原因、可能造成的危害、涉及个人信息的种类、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议和可采取的措施等。我们将及时将事件相关情况以邮件、短信、电话、发送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。请您知悉，根据可适用法律法规的规定，如采取措施能够有效避免信息泄露、篡改、丢失造成危害的，我们可以不向您进行告知。

四、如何管理您的个人信息
1.访问、更新和删除
我们鼓励您更新和修改您的个人信息以使其更准确有效。
如您想查询、修改或删除您的部分信息，请登录账号设置页面，我们为您提供了账号相关信息的修改功能。对于通过Cookies收集的您的信息，我们还在本政策第二条"我们如何使用Cookies"部分说明了向您提供的选择机制。
您也可以通过本政策"如何联系我们"章节所列的反馈渠道联系我们为您处理。我们将采取适当的技术手段或联系渠道，使您可以访问、更新和删除自己的个人信息或使用本服务时提供的其他信息，但法律法规另有规定的除外。
除法律法规另有规定，当您更正、删除您的个人信息时，我们会在15个工作日内从系统中更正或删除相应的信息。
2.帐号注销
我们向您提供帐号注销的途径。
（1）在符合我们的服务条款约定条件及国家相关法律法规规定的情况下，您可以选择通过本政策"如何联系我们"章节所列的反馈渠道联系我们，我们会尽快为您作出解答。
（2）您可以在账号管理界面，点击账号注销的选项。
（3）您可以撤回对本政策的同意，在经过必要的身份验证流程后，我们会确认注销您的账号。
在您的帐号注销之后，我们将停止为您提供部分服务，并依据您的要求，删除您的个人信息或做匿名化处理，但法律法规另有规定的除外。
3.撤回您的授权同意
您总是可以选择是否向我们披露个人信息。有些个人信息是使用本服务所必需的，但大多数其他信息的提供是由您决定的。您可以通过删除信息、关闭设备功能、注销帐号等方式改变您授权我们继续收集信息的范围或撤回您的授权。
当您撤回授权后，我们无法继续为您提供撤回授权所对应的服务，也不再处理您相应的信息。但您撤回授权的决定，不会影响此前基于您的授权而开展的信息处理。
4.个人信息副本获取
如您需要您的个人信息的副本（根据我们保存下来的个人信息输出），您可以通过本政策"如何联系我们"章节所列的反馈渠道联系我们，在核实您的身份后，我们将向您提供您在我们的服务中的个人信息副本（包括基本资料、身份信息），但法律法规另有规定的或本政策另有约定的除外。
5.响应您的上述请求
为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
在以下情形中，我们将无法响应您的请求：
（1）与我们履行法律法规规定的义务相关的；
（2）与国家安全、国防安全直接相关的；
（3）与公共安全、公共卫生、重大公共利益直接相关的；
（4）与刑事侦查、起诉、审判和执行判决等直接相关的；
（5）我们有充分证据表明您存在主观恶意或滥用权利的；
（6）出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
（7）响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
（8）涉及商业秘密的。

五、第三方服务
文石提供的部分功能/服务由我们合作的第三方机构（以下称"SDK技术服务提供方"）以SDK插件的形式提供，SDK技术服务提供方会基于向您提供功能或服务之必须获取相应权限及信息。我们对本软件中集成的SDK均进行了安全监测，确保这些SDK仅使用了为实现其功能或服务的基本权限。您可以通过以下链接来了解相关SDK技术服务提供方处理您个人信息的详情：https://send2boox.com/document.html?version=third-party-policy。

六、未成年人保护
我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的产品或服务。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提交的个人信息之前寻求父母或监护人的同意和指导。我们制定了《文石儿童个人信息保护规则》，若您是不满14周岁的儿童，我们在收集您的个人信息之前，会征得您的父母或其他监护人的同意。

七、通知和修订
为了给您提供更好的服务，我们可能会根据本服务的更新情况及法律法规的相关要求适时修改本政策的条款，该等修改构成本政策的一部分。我们会在本页面上公布对本政策所作的任何变更。对于重大变更，我们还会提供更为显著的通知（包括网站公告、推送通知、弹窗提示或其他方式），本政策所指的重大变更包括但不限于：
（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
（2）我们在所有权结构方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
（3）个人信息共享、转让或公开披露的主要对象发生重大变化；
（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；
（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生重大变化；
（6）其他重要的或可能严重影响您的个人权益的情况发生。
您如果不同意该等变更，可以选择停止使用本服务；如您仍然继续使用本服务的，即表示您已充分阅读、理解并同意受经修订的本政策的约束。

八、如何联系我们
为更好地保护您的个人信息，我们设立有专门的网络安全与数据安全管理部门。如您在使用本服务或文石终端产品的过程中对本政策或对您的个人信息保护有任何疑问或建议，请通过以下联系方式与我们联系：
联系邮箱：support@boox.com
联系地址：广州市海珠区广州大道南桃花街159号经典居3201室
如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，且在您向我们反馈后我们无法提供让您满意的回复且拒绝改进的，您可以向相关监管机构进行投诉和举报。`,
    };
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit("update:visible", newVal);
    },
  },
  created() {
    // 将换行符转换为HTML换行标签，以便正确显示
    this.content = this.content.replace(/\n/g, "<br>");
  },
  methods: {
    handleAgree() {
      this.dialogVisible = false;
      this.$emit("agree");
    },
  },
};
</script>

<style lang="scss" scoped>
// PC端弹窗样式
.privacy-dialog {
  ::v-deep .el-dialog__body {
    padding: 20px;
    max-height: 60vh;
    overflow-y: auto;
  }

  .privacy-dialog-content {
    .privacy-main {
      word-wrap: break-word;
      word-break: break-word;
      line-height: 1.6;
    }
  }

  .dialog-footer {
    text-align: center;

    .agree-btn {
      padding: 12px 40px;
      background: #d47653;
    }
  }
}

// 移动端弹窗样式
.privacy-popup-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .privacy-popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #eee;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 1;

    .privacy-popup-title {
      font-size: 18px;
      font-weight: bold;
    }
  }

  .privacy-popup-content {
    flex: 1;
    padding: 15px;
    overflow-y: auto;

    .privacy-main {
      word-wrap: break-word;
      word-break: break-word;
      line-height: 1.6;
      font-size: 14px;
    }
  }

  .privacy-popup-footer {
    padding: 15px;
    border-top: 1px solid #eee;
    position: sticky;
    bottom: 0;
    background: #fff;
  }
}

.orange {
  background-color: #ce653e;
  border-color: #ce653e;
}
</style>
